import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Bolt, Clock, Award, Truck as TruckFast, Factory } from 'lucide-react';

const advantages = [
  {
    icon: <ShieldCheck className="w-10 h-10 text-primary-600" />,
    title: 'Пожаробезопасность',
    description: 'Сухие трансформаторы не содержат горючего масла, что исключает риск воспламенения и снижает требования к установке.',
  },
  {
    icon: <Bolt className="w-10 h-10 text-primary-600" />,
    title: 'Экономия 5-10%',
    description: 'Снижение эксплуатационных затрат на электроэнергию благодаря низким потерям холостого хода и короткого замыкания.',
  },
  {
    icon: <Clock className="w-10 h-10 text-primary-600" />,
    title: 'Срок производства 50-75 дней',
    description: 'Сокращенные сроки производства по сравнению с конкурентами (60-90 дней), что позволяет ускорить реализацию проектов.',
  },
  {
    icon: <Award className="w-10 h-10 text-primary-600" />,
    title: 'Гарантия 36 месяцев',
    description: 'Расширенная гарантия на всю продукцию компании с возможностью продления гарантийного обслуживания.',
  },
  {
    icon: <TruckFast className="w-10 h-10 text-primary-600" />,
    title: 'Доставка по РФ и СНГ',
    description: 'Организуем доставку оборудования в любую точку России и стран СНГ в течение 5-15 дней с момента готовности.',
  },
  {
    icon: <Factory className="w-10 h-10 text-primary-600" />,
    title: '300+ поставленных трансформаторов',
    description: 'Значительный опыт поставок трансформаторов на различные промышленные и энергетические объекты.',
  },
];

const Advantages: React.FC = () => {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Почему выбирают трансформаторы от Проминнова</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Наши трансформаторы сочетают в себе высокую надежность, экономичность и современные технические решения
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
          {advantages.map((advantage, index) => (
            <div key={index} className="flex">
              <div className="flex-shrink-0 mr-4">{advantage.icon}</div>
              <div>
                <h3 className="text-xl font-semibold mb-2">{advantage.title}</h3>
                <p className="text-gray-600">{advantage.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <Link to="/advantages" className="btn-secondary">
            Все преимущества
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Advantages;